import { Text } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Description = styled(Text, theme => {
  return {
    base: {
      flex: 1,
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      textAlign: 'left',
    },
    variants: {},
  }
})
